import {
  DurationType,
  PauseInputFormik,
  pauseYupValidation,
} from "@modules/boxSubscription/formik/boxSubscriptionFormik"
import { word } from "@modules/core/utils/i18n"
import { ProgramBundleSubscriberEntity } from "@modules/programBundle/programBundleSubscribers/entities/programBundleSubscriberEntity"
import { ProgramSubscriberEntity } from "@modules/programs/programSubscriber/entities/programSubscriberEntity"
import { useProgramSubscriberActions } from "@modules/programs/programSubscriber/hooks/useProgramSubscriber"
import { useToast } from "@modules/ui/components/huToast"
import { useFormik } from "formik"
import { useState } from "react"

export function useSubscriberPauseFormik(
  programId: string,
  subscriber: ProgramSubscriberEntity | ProgramBundleSubscriberEntity,
  moveToSubscriberDetails: () => void,
) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const toast = useToast()
  const { updatePause } = useProgramSubscriberActions(programId, subscriber)

  const onSubmitForm = async () => {
    setIsSubmitting(true)

    await updatePause(formik.values)
      .then(() => {
        toast.show({
          severity: "success",
          detail: word("program.subscribers.subscriptionDetails.pause.success"),
        })
        moveToSubscriberDetails()
      })
      .catch((error: any) => {
        toast.show({
          severity: "error",
          summary: word("global.error.label"),
          detail: error.message,
        })
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  const formik = useFormik<PauseInputFormik>({
    enableReinitialize: true,
    initialValues: {
      durationType: DurationType.MONTHLY,
      months: 1,
    },
    validationSchema: pauseYupValidation(),
    onSubmit: onSubmitForm,
  })

  return { formik, isSubmitting }
}
